export default {
  // Chưa gửi Thủ trưởng duyệt
  FileNotSent: 1,
  // Chờ duyệt: 0
  Waiting: 0,
  // Kế toán trưởng từ chối duyệt
  CompanyChiefAccountantReject: -1,
  // Chờ thủ trưởng duyệt
  WaitingCompanyDirector: 2,
  // Thủ trưởng đã duyệt
  CompanyDirectorApproved: 3,
  // Thủ trưởng từ chối duyệt
  CompanyDirectorReject: -2,
};
